import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface UpdateMainDealerPayload {
  id: number;
  password?: string;
  image?: string | null;
  balance?: number;
  bettingRulesLocked?: boolean;
}

export async function updateMainDealer(
  payload: UpdateMainDealerPayload
): Promise<NewUser> {
  const { id, ...body } = payload;
  const res = await api.client.patch(`/dealers-new/${id}`, body);
  return res.data;
}
